var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6327 9.11723C34.7491 9.23335 34.8414 9.37129 34.9045 9.52315C34.9675 9.67501 34.9999 9.83782 34.9999 10.0022C34.9999 10.1667 34.9675 10.3295 34.9045 10.4813C34.8414 10.6332 34.7491 10.7711 34.6327 10.8872L17.1327 28.3872C17.0166 28.5036 16.8786 28.596 16.7268 28.659C16.5749 28.722 16.4121 28.7545 16.2477 28.7545C16.0833 28.7545 15.9205 28.722 15.7686 28.659C15.6167 28.596 15.4788 28.5036 15.3627 28.3872L6.61267 19.6372C6.37796 19.4025 6.24609 19.0842 6.24609 18.7522C6.24609 18.4203 6.37796 18.102 6.61267 17.8672C6.84739 17.6325 7.16573 17.5007 7.49767 17.5007C7.82961 17.5007 8.14796 17.6325 8.38267 17.8672L16.2477 25.7347L32.8627 9.11723C32.9788 9.00083 33.1167 8.90847 33.2686 8.84545C33.4205 8.78244 33.5833 8.75 33.7477 8.75C33.9121 8.75 34.0749 8.78244 34.2268 8.84545C34.3786 8.90847 34.5166 9.00083 34.6327 9.11723V9.11723Z",
    fill: "#D30422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico_check.5b9e94f4df9e6f3798ecd5942624f058.svg";
export { ForwardRef as ReactComponent };